import React, { useState } from "react";
import { useParams } from "react-router-dom";
//import { Identity } from "../../../../components/Identity";
import { PageTopbar } from "../../../../components/Page/Topbar";
import { PageHeader } from "../../../../components/Page/Header";
import { AppScan } from "../../../../app/Scan";
import { getPageTitle } from "../../../../app/helpers/global";

export function RoutesArticlesProductActionsScan({ title, parents, current }) {

    let identifier = (parents+current).replaceAll('/', '-');
    let group = parents.indexOf('articles/depot')===-1 ? 'location' : 'depot';

    const { productId } = useParams();
    const [ pageTitle, setPageTitle] = useState(null);

    if (pageTitle === null) {
        getPageTitle('product', productId, setPageTitle);
    }
    return (
        <>
            <PageTopbar
                parents={parents}
                current={current}
            />
            
            {/* <Identity /> */}

            <PageHeader
                title={pageTitle}
                parents={parents}
                current={current}
                tabGroup={"product-details-" + group}
                variables={{productId:productId}}
                identifier={identifier}
            />

            <AppScan
                productId={productId}
                method="add"
                title={title}
                returnPath={"/" + parents + "/" + productId}
                forward={"/" + parents.replace('/actions', '/details') + "/" + productId}
            />
        </>
    );
}